<template>
  <div>
    <img
      :src="(safeImgUrl)"
      style="width: 60%;"
    />
    
    <br />
    {{ $t("recharge.address") }}
    <p>{{ safeAccount }}</p>
    <van-button class="web-btn-1" style="min-width: 120px" @click="copy()">{{
      $t("common.copy")
    }}</van-button>
  </div>
</template>

<script>
export default {
  name: "QrCodeRecharge",
  props:['imgurl','account'],
  computed:{
    safeImgUrl(){
        return this.imgurl || ''
    },
    safeAccount(){
        return this.account || ''
    }
  },
  methods:{
    copy() {
      // 创建input标签
      var input = document.createElement("input");
      input.value = this.safeAccount;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      this.$toast.success(this.$t("common.copysuccessful"));
      document.body.removeChild(input);
    },
  }
};
</script>

<style>
</style>
